export enum ContainerDisposition {
  Single,
  DualVertical,
  DualHorizontal,
}